import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as CompanyIcon } from 'assets/icons/companyInfo2.svg';
import { Links } from 'settings';

import {
  InnerContainer,
  DescriptionW,
  FlexW,
  SectionTitle,
  SubTitle,
  PreviewSection,
  CompanyCardHeader,
  CompanyIconBg,
} from './styled';

export function OtherResources(): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCompanyClick = () => {
    navigate(Links.we.companyInfo);
  };

  return (
    <PreviewSection>
      <SectionTitle>{t('resources.otherResources.title')}</SectionTitle>

      <InnerContainer>
        <FlexW onClick={handleCompanyClick}>
          <CompanyCardHeader>
            <CompanyIconBg>
              <CompanyIcon />
            </CompanyIconBg>
          </CompanyCardHeader>
          <DescriptionW>
            <SubTitle>{t('resources.otherResources.subTitle')}</SubTitle>
          </DescriptionW>
        </FlexW>
      </InnerContainer>
    </PreviewSection>
  );
}
